import { css } from '@emotion/core';
import { B300, N500 } from '@atlaskit/theme/colors';
import { token } from '@atlaskit/tokens';

import {
  flexDirectionColumn,
  flex,
  SPACE_COMFORTABLE,
  SPACE_COMPACT,
  card,
  SPACE_MINIMUM,
} from '@/styles';

export const teamListStyles = css`
  padding-left: 0;
  ${flex};
  ${flexDirectionColumn};
  gap: ${SPACE_COMPACT + SPACE_MINIMUM}px;
  li {
    cursor: pointer;
    list-style: none;
    padding: ${SPACE_COMFORTABLE}px;
    ${card};
    h5 {
      font-weight: 400;
      font-size: 20px;
    }
    &,
    i {
      transition-duration: 150ms;
      position: relative;
      left: 0px;
    }
    &:hover {
      box-shadow: 0px 1px 3px ${token('color.border.input', N500)},
        0px 0px 5px ${token('color.border.input', N500)};
      i {
        color: ${token('color.text.accent.blue', B300)};
        left: ${SPACE_MINIMUM}px;
      }
    }
  }
`;

export const teamListIconStyles = css`
  color: ${token('color.text.subtle', N500)};
`;
